import React, { InputHTMLAttributes } from "react";

interface TextInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  containerClassName?: string;
}

const TextInput: React.FC<TextInputProps> = ({
  label,
  error,
  containerClassName = "",
  ...inputProps
}) => (
  <div className={`mb-3 ${containerClassName}`}>
    {label && (
      <label className="form-label">
        {label}
        {inputProps.required && <span className="text-danger">*</span>}
      </label>
    )}
    <input
      {...inputProps}
      className={`form-control form-control-custom ${inputProps.className || ""}`}
    />
    {error && <div className="text-danger small mt-1">{error}</div>}
  </div>
);

export default TextInput;
